import React from 'react';

import TextBlock from '../TextBlock';
import IconListItem, { IconListItemProps } from '../IconListItem';

import styles from './index.module.scss';

export interface ContentSectionListCardProps {
  eyebrow?: string;
  title: string;
  text?: string;
  listItems: IconListItemProps[];
}

const ContentSectionListCard: React.FC<ContentSectionListCardProps> = ({
  eyebrow,
  title,
  text,
  listItems,
}) => {
  return (
    <div className={styles.wrapper}>
      <TextBlock
        className={styles.textBlock}
        eyebrow={eyebrow}
        title={title}
        text={text}
      />

      {listItems && listItems.length > 0 && (
        <ul className={styles.listWrapper}>
          {listItems.map((item) => (
            <IconListItem
              key={item.title || item.text}
              iconUrl={item.iconUrl}
              title={item.title}
              text={item.text}
              className={styles.divider}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

export default ContentSectionListCard;
